<template>
    <div class="modal-goodslist">
        <div class="modal">
            <div class="modal-header">
                <div style="padding: 6px;">选择消防用户</div>
                <div style="folat:right">
                    <el-button type="danger" @click="closeSelf">关闭</el-button>
                </div>
            </div>
            <div class="modal-body" :style="bodyStyle">
                <el-row>
                    <div style="float:right">
                        <el-input  placeholder="请输入用户姓名" v-model="name" clearable style="margin:0 5px;width:200px"></el-input>
                        <el-select
                            v-model="departmentCode"
                            style="margin:0 5px;width:200px"
                            clearable
                            placeholder="请选择用户所属部门">
                            <el-option
                                v-for="item in departmentList"
                                :key="item.departmentCode"
                                :label="item.name"
                                :value="item.departmentCode">
                            </el-option>
                        </el-select>
                        <el-select
                            v-model="status"
                            style="margin:0 5px;width:200px"
                            placeholder="请选择用户状态">
                            <el-option
                                v-for="(item,i) in statusValue"
                                :key="i"
                                :label="item[1]"
                                :value="item[0]">
                            </el-option>
                        </el-select>
                        <el-select
                            v-model="userType"
                            style="margin:0 5px;width:200px"
                            placeholder="请选择用户用户类型">
                            <el-option
                                v-for="(item,i) in userTypeValue"
                                :key="i"
                                :label="item[1]"
                                :value="item[0]">
                            </el-option>
                        </el-select>
                        <el-button style="margin-left:10px;float:right" type="primary" icon="el-icon-search" @click="getList">搜索</el-button>
                    </div>
                </el-row>
                <el-row style="margin-top:20px">
                    <el-col :span="24">
                        <el-table
                            :data="elderlyInfo"
                            style="width: 100%" border height="600">
                            <el-table-column prop="name" label="姓名"></el-table-column>

                            <el-table-column prop="phone" label="手机号"></el-table-column>
                           
                            <el-table-column prop="departmentName" label="部门"></el-table-column>
                            <el-table-column prop="userType" :formatter="getUserType" label="用户类型"></el-table-column>
                            <el-table-column
                                    prop="Status"
                                    :formatter="statusTitle"
                                    label="状态">
                            </el-table-column>

                            <el-table-column label="操作" width="150">
                                <template slot-scope="scope">
                                    <el-button type="primary" size="small" @click="handle(scope.$index, scope.row)">添加记录</el-button>
                                </template>
                            </el-table-column>
                        </el-table>
                    </el-col>
                </el-row>
                <div style="text-align: left;background-color: #fff;padding: 10px;">
                    <div style="float: left;padding: 5px;">共{{totalItems}}条（{{Math.ceil(totalItems/pageSize)}}页）
                    </div>
                    <div style="float: left;">
                        <el-pagination
                                background
                                layout="prev, pager, next"
                                :total="totalItems"
                                :page-size="20"
                                @current-change="current_change">
                        </el-pagination>
                    </div>
                    <div style="clear: both;"></div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>

    import {timeStr} from "@/common/times";
    import {hex_md5} from "@/common/Base64MD5";
    import {getStaffCode} from "@/utils/auth";


    export default {
        name: 'Add',
        data() {
            return {
                name:'',
                status:-1,
                userType:-1,
                departmentCode:'',
                userTypeValue:[[-1,'用户类型'],[3,'医生'],[4,'护士'],[5,'护工'],[6,'员工'],[7,'保安']],
                statusValue:[[-1,'用户状态'],[0,'正常'],[1,'禁用']],
                departmentList:[],
                showModalRecharge:false,
                multipleSelection:'',
                loading: false, 
                elderlyInfo:[],
                totalItems:0,
                pageSize:20,
                currentPage:1,
                bodyStyle:"height:"+(this.$store.state.tableHeight+50)+'px',
                th:this.$store.state.tableHeight,
                
            }
        },
        watch: {
            //监听全局变量
            '$store.state.tableHeight' : function(val){
                console.log(val);
                this.bodyStyle = "height:"+(val+50)+'px';
                this.th=val
            },
        },
        methods: {
            init(){
                this.$axios({
                    method: 'post',
                    url: this.$institutionUrl+"Department/List",
                    data: {
                        timeStr:timeStr,
                        sign:hex_md5("timeStr=" + timeStr + "&key="+this.$signKey),
                        staffCode:getStaffCode(),
                    }
                }).then(
                    (response) => {
                        this.loading = false;
                        if (response.data.error == 0) {
                            this.departmentList=response.data.data
                        }else if(response.data.error == 1){
                            this.$message({type: 'info', message: response.data.message});
                        }
                    }
                )
                this.getElderly()
            },
            closeSelf() {
                this.$emit("closeAdd");
            },
            handleSelectionChange(val) {
                this.multipleSelection = val;
            },
            handle(index,row){
                this.$prompt('请输入消防信息', '消防', {
                    confirmButtonText: '确定',
                    cancelButtonText: '取消',
                    inputPattern:'',
                    inputErrorMessage:'请输入消防信息',
                    inputType:'textarea'
                }).then(({ value }) => {
                    if(!value){
                        this.$message({type: 'info', message:'请输入消防信息'});
                        return
                    }
                    this.$axios({
                        method: 'post',
                        url: this.$institutionUrl+"FireRecord/Add",
                        data: {
                            timeStr:timeStr,
                            sign:hex_md5("timeStr=" + timeStr + "&key="+this.$signKey),
                            staffCode: getStaffCode(),
                            userCode:row.userCode,
                            remarks:value,
                        }
                    }).then(
                        (response) => {
                            this.loading = false;
                            if (response.data.error == 0) {
                                this.$emit("getList");
                                this.$emit("closeAdd");
                            }else if(response.data.error == 1){
                                this.$message({type: 'info', message: response.data.message});
                            }
                        }
                    )
                }).catch(() => {
                    this.$message({
                        type: 'info',
                        message: '取消输入'
                    });       
                });
            },
            changeThreeDay(){
                this.checked?this.searchForm.isRecharge=1:this.searchForm.isRecharge=0;
                this.getElderly()
            },
            getList(){
                this.$emit("getList");
                this.getElderly();
            },
            current_change:function(currentPage){
                this.pageIndex = currentPage;
                this.getElderly();
            },
            handleRecharge(index, row) {
                this.$refs.myRecharge.init(row);
                this.showModalRecharge = !this.showModalRecharge;
            },
            closeRecharge:function(){
                this.showModalRecharge = !this.showModalRecharge;
            },
            statusTitle(row){
                if(row.status == 0){
                    return "正常";
                }
                if(row.status == 1){
                    return "禁用";
                }
                return "其它";
            },
            getUserType(row,index,column){
                return this.allStatus(column,['默认','老人','子女','医生','护士','护工','员工'])
            },
            allStatus(row,status){
                for(var i in status){
                    if(i==row){
                        return status[i]
                    }
                }
                return "其它";
            },
            getElderly(){
                var departmentCode=this.departmentCode
                if(!departmentCode){
                    departmentCode='00000000-0000-0000-0000-000000000000'
                }
                this.$axios({
                    method: 'post',
                    url: this.$institutionUrl+"User/Page",
                    data: {
                        timeStr:timeStr,
                        sign:hex_md5("timeStr=" + timeStr + "&key="+this.$signKey),
                        staffCode: getStaffCode(),
                        phone:this.phone,
                        name:this.name,
                        status:this.status,
                        userType:this.userType,
                        departmentCode:departmentCode,
                        pageIndex:this.currentPage,
                        pageSize:this.pageSize,
                    }
                }).then(
                    (response) => {
                        this.loading = false;
                        if (response.data.error == 0) {
                            this.elderlyInfo=response.data.data.list;
                            this.totalItems = response.data.data.total;
                        }else if(response.data.error == 1){
                            this.$message({type: 'info', message: response.data.message});
                        }
                    }
                )
            },
        }
    }


</script>





<style lang="scss" scoped>

    .modal-goodslist {
        position: fixed;
        top: 0;
        right: 0;
        bottom: 0;
        left: 0;
        background-color: rgba(0,0,0,.3);
        display: flex;
        justify-content: center;
        align-items: center;
        z-index: 99;

    .modal {
        background-color: #fff;
        box-shadow:  0 2px 4px rgba(0, 0, 0, .12), 0 0 6px rgba(0, 0, 0, .04);
        overflow-x:auto;
        display: flex;
        flex-direction: column;
        border-radius: 10px;
        width:1180px;

            .modal-header {
                border-bottom: 1px solid #eee;
                color: #313131;
                justify-content: space-between;
                padding: 10px 20px;
                display: flex;
            }
            .modal-body {
                position: relative;
                padding: 20px 20px 0;
                z-index: 99;
                height: 100%;
            }
            .modal-body /deep/ .el-card.is-always-shadow{
                box-shadow:none;
                border-bottom: none;
                margin-bottom: 20px;
            }
            .modal-body /deep/ .el-form-item{
                margin: 0 5px 0 0;
            }
            .modal-footer {
                border-top: 1px solid #eee;
                justify-content: center;
                padding: 15px;
                display: flex;
                .el-button{
                    width: 15%;
                }
            }


        }

    }



    .row{
        padding: 10px 0px;
    }
    .item{
        padding: 0px 20px;
    }
    .label{
        padding: 5px 0px;
    }


</style>
